import config from '../config';

const useRaffleOwner = (id) => {
  const owner = config.raffleOwners.find((owner) => owner.id === id);

  if (!owner) {
    return config.raffleOwners[0];
  }

  return owner;
};

export default useRaffleOwner;
